module.exports = __webpack_public_path__ + "static/img/dashboard-background.cd193140.png";